<template>
    <div class="service">
        <p class="text">{{valueService.desc}}</p>
        <div class="list">
            <div class="item">
                <div class="switch">
                    <img src="@/assets/images/icon_value_service_01.png" alt="" class="icon">
                    <p>{{valueService.name1}}</p>
                </div>
                <div class="desc">{{valueService.text2}}</div>
            </div>
            <div class="item">
                <div class="switch">
                    <img src="@/assets/images/icon_value_service_02.png" alt="" class="icon">
                    <p>{{valueService.name2}}</p>
                </div>
                <div class="desc">{{valueService.text2}}</div>
            </div>
            <div class="item">
                <div class="switch">
                    <img src="@/assets/images/icon_value_service_03.png" alt="" class="icon">
                    <p>{{valueService.name3}}</p>
                </div>
                <div class="desc">{{valueService.text3}}</div>
            </div>
        </div>
        <div class="title">社群活动剪影</div>
        <ValueImages :data="valueService.pictures"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ValueImages from '../../components/valueImages.vue';
export default {
    name: "service",
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['valueService'])
    },
    components: {
        ValueImages
        
    },
    mounted() {
        this.$store.dispatch('getValueService');
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.service{
    padding: .8rem 0;
    @media only screen and (max-width: 1200px) {
        padding: 1rem 0;
    }
}
.text{
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem;
    }
}
.list{
    display: flex;
    justify-content: space-between;
    margin: .6rem 0 .8rem;
    .item{
        width: 3.9rem;
        color: #fff;
        &:hover{
            background: rgba($color: #ff4a32, $alpha: .7);
            border-radius: .04rem;
            .switch{
                background: #ff4a32;
            }
            .desc{
                display: block;
            }
        }
        .switch{
            height: .66rem;
            border-radius: .04rem;
            background: #403c3c;
            font-size: .2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .icon{
                width: .48rem;
                margin-right: .2rem;
            }
        }
        .desc{
            display: none;
            padding: .2rem .25rem;
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        margin-bottom: 0;
        .item{
            width: 100%;
            .switch{
                height: 2.92rem;
                border-radius: 0;
                font-size: .6rem;
                padding: 0 2.4rem 0 1rem;
                text-align: center;
                p{
                    flex: 1;
                }
                .icon{
                    width: 1.4rem;
                    margin-right: 0;
                }
            }
            .desc{
                padding: 1rem;
            }
        }
    }
}
.title{
    font-size: .26rem;
    margin-bottom: .3rem;
    @media only screen and (max-width: 1200px) {
        margin-bottom: 0;
        padding: 1rem 0;
        font-size: .72rem;
        text-align: center;
    }
}
</style>